import { css } from 'styled-components';
import token from 'styled-token';
import { StyledChipSpinner } from '../../components/AssistChip/ChipSpinner.styles';
import { StyledAvatar } from '../../components/Avatar/Avatar.styles';
import { StyledButtonIcon } from '../../components/ButtonIcon/ButtonIcon.styles';
import { sizeMixin } from '../sizeMixin';
import { spaceMixin } from '../spaceMixin';
import { ChipMixin } from './ChipMixin';
var loadingCSS = function loadingCSS(props) {
  var loading = props.loading;
  if (!loading) {
    return '';
  }
  return token({
    opacity: 'Chip.opacity.disabled',
    spinnerSize: 'Chip.spinnerSize'
  }, function (_ref) {
    var spinnerSize = _ref.spinnerSize,
      opacity = _ref.opacity;
    return css(["pointer-events:none;opacity:", ";", ",", "{display:none;}", "{line-height:", "px;margin-right:", ";}"], opacity, StyledAvatar, StyledButtonIcon, StyledChipSpinner, spinnerSize, spaceMixin('xs')(props));
  })(props);
};

/** @class AssistChipMixin */
/** @method */
export var AssistChipMixin = function AssistChipMixin(props) {
  return token({
    borderWidth: "Chip.borderWidth",
    fontType: "Chip.fontType",
    height: "Chip.height"
  }, function (_ref2) {
    var borderWidth = _ref2.borderWidth,
      fontType = _ref2.fontType,
      height = _ref2.height;
    return css(["", " justify-content:left;", " ", ""], ChipMixin(props), sizeMixin({
      fontType: fontType,
      borderWidth: borderWidth * 2,
      size: height
    })(props), loadingCSS(props));
  })(props);
};